import React, {Component} from "react";

// Assets
import PlusIcon from "../../Assets/plus.svg";
import MinusIcon from "../../Assets/minus.svg";
import DoubleArrowIcon from "../../Assets/chevrons-right.svg";
import SearchIcon from "../../Assets/search.svg";

// Insulin Data Component
export default class InsulinData extends Component {
  // constructor function
  constructor(props) {

    super(props);

    this.state = {
      activePage: true,
      searchDataList: [],
      insulinName: "",
      insulinData: [
        "Human Actrapid 40IU/ml",
        "Huminsulin R 40IU/ml",
        "Actrapid HM 100IU/ml",
        "Insugen R 40IU/ml",
        "Actrapid 100IU/ml",
        "Lupisulin R 40IU/ml",
        "Insuman Rapid 100IU/ml",
        "Wosulin R 40IU/ml",
        "Human Monotard 40IU/ml",
        "Recosulin R 40IU/ml",
        "Human Mixtard 30/70 40IU/ml",
      ],
    };
  }

  // Page Change Logic Function
  onPageChange() {
    if (this.state.activePage) this.setState({ activePage: false });
    else this.setState({ activePage: true });
  }

  // To Display Insulin List
  insulinListDisplay(insulinList, dataType) {
    return insulinList.map((insulinName) => {
      return (
        <div className="Profile_InsulinBar">
          <div className="Profile_IBName">{insulinName}</div>
          <button
            className="Profile_InsulinMinus"
            style={
              dataType === 1
                ? { backgroundImage: `url(${MinusIcon})` }
                : { backgroundImage: `url(${PlusIcon})` }
            }
            onClick={
              dataType === 1
                ? () => {
                    this.props.removeInsulin(insulinName);
                  }
                : () => {
                    this.props.addInsulin(insulinName);
                  }
            }
          ></button>
        </div>
      );
    });
  }

  // First Page of Insulin Data
  selectedData() {
    return (
      <>
        <div className="Profile_IDBlock">
          <div
            className="Profile_IDNewPage_Btn"
            onClick={() => this.onPageChange()}
          >
            <div className="Profile_IDBtn_Title">
              Select Insulin Name That You Intake
            </div>
            <div className="Profile_IDBtn_Image">
              <img src={DoubleArrowIcon} alt="Insulin Selection Button" />
            </div>
          </div>

          <div className="Profile_IDSelected">
            <div className="Profile_IDSelected_Title">
              Selected Insulin List
            </div>
            <div className="Profile_IDSelected_List">
              {this.insulinListDisplay(this.props.insulinIntake, 1)}
            </div>
          </div>
        </div>
      </>
    );
  }

  // Search Bar Logic
  searchBar(data) {
    if (data !== undefined) {
      return data.filter(
        (data) =>
          data.toLowerCase().indexOf(this.state.insulinName.toLowerCase()) > -1
      );
    }
  }

  // Second Page of Insulin Data
  selectData() {
    return (
      <div className="Profile_IDSelectBlock">
        <div className="Profile_IDSelectBlock_MainTitle">
          Select Your Insulin Intake
        </div>
        <div className="Profile_IDSearchBlock">
          <input
            type="search"
            className="Profile_IDSearchBar"
            placeholder="Enter Insulin Name"
            style={{ backgroundImage: `url(${SearchIcon})` }}
            onChange={(e) => {
              this.setState({ insulinName: e.target.value });
            }}
          />
          <div
            className="Profile_IDSearchDone"
            onClick={() => {
              this.onPageChange();
            }}
          >
            Done
          </div>
        </div>

        <div className="Profile_IDSelectedBlock">
          <div className="Profile_ID_SDB1Title">Selected List</div>
          <div className="Profile_ID_SDB1List">
            {this.insulinListDisplay(this.props.insulinIntake, 1)}
          </div>
        </div>

        <div className="Profile_IDSearchedBlock">
          <div className="Profile_ID_SDB2Title">Searched List</div>
          <div className="Profile_ID_SDB2List">
            {this.insulinListDisplay(this.searchBar(this.state.insulinData), 2)}
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="Profile_InsulinData_Component">
        <div className="Profile_IDTitle">Insulin Intake Information</div>
        {this.state.activePage ? this.selectedData() : this.selectData()}
      </div>
    );
  }
}
